import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
  listarPedidos,
  gerarExelPedido,
} from "../../../services/http/pedidosService";

import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../hooks/snackBar";
import { saveAs } from "file-saver";
import FormControl from "@material-ui/core/FormControl";
import InputSearch from "../../../components/InputSearch";

import "./styles.scss";
import ListGestaoPedidos from "./ListGestaoPedidos";

const GestaoPedidos = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const [busca, setBusca] = useState("");
  const [pedido, setPedidos] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const carregarListaPedidos = (pagina) => {
    trackPromise(
      listarPedidos(busca, pagina).then((res) => {
        if (res.data) {
          setPedidos(res.data);
        }
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const CarregarListaPedidosComFiltro = (filtro, pagina) => {
    trackPromise(
      listarPedidos(filtro, pagina).then((res) => {
        if (res.data) {
          setPedidos(res.data);
        }
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const extrairBase = () => {
    trackPromise(
      gerarExelPedido().then((res) => {
        if (res.data) {
          saveAs(res.data, "Pedidos.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base de pedido",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base de pedido",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaPedido = (page) => {
    busca != ""
      ? CarregarListaPedidosComFiltro(busca, page)
      : carregarListaPedidos(page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        CarregarListaPedidosComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      carregarListaPedidos(1);
    }
  }, [busca]);

  useEffect(() => {
    carregarListaPedidos(1);
  }, []);

  return (
    <div className="gestao-pedidos-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Gestão de Pedidos</h2>
        </div>
      </div>

      {/* Botões de ação */}
      <div className="row mb-3">
        <div className="col-sm-4 col-md-4 mb-2">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            onClick={extrairBase}
          >
            EXTRAIR BASE
          </button>
        </div>
      </div>

      <ListGestaoPedidos
        response={pedido}
        mudarPagina={mudarPaginaPedido}
        buscar={buscar}
        busca={busca}
      />
    </div>
  );
};

export default GestaoPedidos;
